import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Zone from '@wix/da-gruser-shared/pkg/components/Zone';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import GruserContext from '@wix/da-gruser-shared/pkg/context/GruserContext';
import LazyContext from '@wix/da-shared-react/pkg/LazyLoadingImage/LazyContext';
import {
  getProfileGruser,
  getProfileOwnerUser,
} from '../../../selectors/users';
import { getHomeWidgetConfigs } from './homeWidgetConfigs';

import s from './HomeSection.scss';

export interface Props {}

const HomeSection: React.FC<Props> = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const gruser = useSelector(getProfileGruser);
  const profileOwnerUser = useSelector(getProfileOwnerUser);

  const homeWidgetConfigs = getHomeWidgetConfigs({ t, dispatch });

  const renderTwoColumns = () => (
    <>
      <div className={s['zone-top']}>
        <Zone
          name="topBar"
          mapModuleTypeToWidgetConfig={homeWidgetConfigs.topBar}
        />
      </div>
      <div className={s['flex-wrap']}>
        <div className={s['zone-column-left']}>
          <Zone
            name="bottomLeft"
            mapModuleTypeToWidgetConfig={homeWidgetConfigs.bottomLeft}
          />
        </div>
        <div className={s['zone-column-right']}>
          <Zone name="topRight" mapModuleTypeToWidgetConfig={{}} />
          <Zone
            name="midRight"
            mapModuleTypeToWidgetConfig={homeWidgetConfigs.midRight}
          />
          <Zone
            name="bottomRight"
            mapModuleTypeToWidgetConfig={homeWidgetConfigs.bottomRight}
          />
        </div>
      </div>
    </>
  );

  return (
    <div className={s['root']}>
      <BiLoggerContextProvider
        value={{ creatorid: profileOwnerUser.useridUuid }}
      >
        <GruserContext.Provider
          value={{ gruser, gruserOwner: profileOwnerUser }}
        >
          <LazyContext.Provider value={true}>
            {renderTwoColumns()}
          </LazyContext.Provider>
        </GruserContext.Provider>
      </BiLoggerContextProvider>
    </div>
  );
};
HomeSection.displayName = 'HomeSection';

export default HomeSection;
